import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import { TypeTraining } from '../../../services/models';
import Card from '../Card';
import CustomDots from '../../../components/Training/CustomDots';
import useStyles from './styles';

interface Props {
  trainings: TypeTraining[];
}

const TrainingCarousel = ({ trainings }: Props) => {
  const classes = useStyles();

  const responsive = {
    desktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 1,
      partialVisibilityGutter: 0,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      partialVisibilityGutter: 0,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      partialVisibilityGutter: 0,
    },
  };

  const cards = trainings.map((training) =>
    <Card key={training.id} training={training} />
  );

  return (
    <Grid item xs={12} className={classes.container}>
      {trainings.length === 0 ? (
        <Typography variant='subtitle2'>Sem Treinamentos</Typography>
      ) : (
        <Carousel
          additionalTransfrom={0}
          minimumTouchDrag={80}
          responsive={responsive}
          slidesToSlide={1}
          containerClass={classes.carouselContainer}
          itemClass={classes.item}
          dotListClass={classes.dotList}
          customDot={<CustomDots />}
          arrows={false}
          focusOnSelect={false}
          showDots
          renderDotsOutside
          swipeable
          draggable
        >
          {cards}
        </Carousel>
      )}
    </Grid>
  );
}

export default TrainingCarousel;